export default {
  pending: 'pending',
  active: 'active',
  completed: 'completed',
  failed: 'failed',
  waitingApproval: 'waitingApproval',
  archived: 'archived'
};
